

export class ReportBatch {
    Id: number;
    TotalNumberOfStudents: number;
    NumberOfStudentsCompleted: number;
    BatchDescription: string;
    ReportName: string;
    IsSysGen: number;
    AddedByLogin_Id: number;
    AddedOn: Date;
    AddedByName: string;
    ErrorMessage_Id: number;
    HasError: boolean;
    ErrMsg = '';
    ProcessingDescription: string;
    Cancel: boolean;
    InProcess: boolean;
    OperationDescriptions: string;
    Operations: ReportBatchOperation[] = [];
    RemoveArchivedFiles: boolean;
    ShowTotalNumberOfStudents: boolean;
    // SkipActuallyArchivingReport = false; // for testing process without actually pushing report out

    AddedOnDate_Display: string;
    AddedOnTime_Display: string;

    viewArchiveProcessesFromAllUsers: boolean;
    allowCancelArchiveProcesses: boolean;
    allowDeleteArchivedReports: boolean;

    sendEmailNotification: boolean;
    DistributeByEmailOption: string; // comma delimited string, 1 = Student, 2 = PrimaryContact, 3 = AllElectronicContacts

    EmailFrom: string;
    EmailsToSendReport: string;
    EmailSubject: string;
    EmailBody: string;
}

export class ReportBatchOperation {
    Batch_Id: number;
    Operation_Id: number;
    OperationOrder: number;
    OperationDescription: string;
    ProcessingDescription: string;
    CurrentStudent_Id: number;
    ErrorMessage_Id: number;
    HasError: boolean;
    ErrMsg = '';
    // RemoveArchivedFiles: boolean;
}

